export default __webpack_public_path__ + "onboardingDevices.526df502.png";